import { render, staticRenderFns } from "./editMajorDisease.vue?vue&type=template&id=370c84e2"
import script from "./editMajorDisease.vue?vue&type=script&lang=js"
export * from "./editMajorDisease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports